<template>
  <v-container fluid style="height: 100%;">
    <v-row>
      <v-col sm="12" lg="6" md="6" cols="12">
        <v-card v-if="viewSkeletonsT">
          <v-col cols="12">
            <div :class="skeletonTitleT" :style="backgroundSkeleton"></div>
          </v-col>
          <v-col cols="12">
            <div :class="skeletonColumnT" :style="backgroundSkeleton"></div>
          </v-col>
        </v-card>
        <v-card>
          <highcharts id="traffic"></highcharts>
        </v-card>
      </v-col>
      <v-col cols="12" align="left">
        <h3 style="font-weight: 500;">
          <v-icon :color="colorTheme">mdi-map-marker-radius</v-icon>
          {{ $t("traffic").toUpperCase() }}
        </h3>
      </v-col>
      <v-col lg="3" md="3" sm="4" cols="12" style="padding-bottom: 0; max-height: 60px;">
        <v-text-field
          solo
          :label="$t('search')"
          append-icon="mdi-magnify"
          single-line
          v-model="search"
          :color="colorTheme"
        ></v-text-field>
      </v-col>
      <v-col lg="2" md="2" sm="4" cols="12" style="padding-bottom: 0;">
        <v-select
          :items="optionsTraffic"
          solo
          :color="colorTheme"
          v-model="filterTraffic"
          :label="$t('filterVehicles')"
        ></v-select>
      </v-col>
      <v-col lg="2" md="2" sm="4" cols="12" style="padding-bottom: 0;">
        <v-btn
          style="width: 100%; margin: 0;"
          large
          :color="colorTheme"
          class="white--text"
          v-on:click="openAddTravel(null)"
        >
          {{ $t("newTrip").toUpperCase() }}
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col lg="12" sm="12" md="12">
        <v-data-table
          :no-data-text="$t('noResults')"
          :headers="headersTraffic"
          :items="trafficList"
          :search="searchTraffic"
          item-key="MovilId"
          :items-per-page="5"
          class="elevation-1"
          :loading="progressOver"
          :loading-text="$t('loadingTextForTable')"
          single-expand="true"
          show-expand
          :expanded.sync="expanded"
          :footer-props="{
            'items-per-page-text': $t('rows'),
            'items-per-page-all-text': $t('all')
          }"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">
              <v-icon :color="colorTheme">mdi-map-marker</v-icon>
              {{ props.item.vehicle }}
            </td>
            <td class="text-xs-left">{{ props.item.address }}</td>
            <td class="text-xs-left">{{ props.item.date }}</td>
            <td class="text-xs-left">{{ props.item.idletime }}</td>
            <td class="text-xs-left">{{ props.item.status }}</td>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td v-if="item.statusId == 1" :colspan="headers.length">
              <v-row>
                <v-col align="left" lg="3" md="3" sm="12" cols="12" style="padding-bottom: 0;">
                  <v-row>
                    <v-col cols="12">
                      <h3 style="font-weight: 500;">
                        <v-icon :color="colorTheme">mdi-directions</v-icon>
                        {{ item.info.travelName }} ({{ item.info.pathName }})
                      </h3>
                    </v-col>
                    <v-col cols="12">
                      <h3 style="font-weight: 500;">
                        <v-icon :color="colorTheme">mdi-account</v-icon>
                        {{ item.info.operator }} ({{ item.info.number }})
                      </h3>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col align="left" lg="2" md="2" sm="12" cols="12" style="padding-bottom: 0;">
                  <v-row>
                    <v-col cols="12" style="padding-bottom: 0;">
                      <h3 style="font-weight: 500;">
                        <v-icon :color="colorTheme">mdi-calendar-blank</v-icon>
                        {{ item.info.start }}
                      </h3>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-col>
                    <v-col cols="12" style="padding-top: 0;">
                      <h3 style="font-weight: 500;">{{ $t("inProgress") }}</h3>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col align="left" lg="4" md="4" sm="12" cols="12" style="padding-bottom: 0;">
                  <v-row>
                    <v-col cols="12" style="padding-bottom: 0;">
                      <h3 style="font-weight: 500;">
                        <v-icon :color="colorTheme">mdi-map-marker</v-icon>
                        {{ item.info.origin }}
                      </h3>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-col>
                    <v-col cols="12" style="padding-top: 0;">
                      <h3 style="font-weight: 500;">
                        <v-icon :color="colorTheme">mdi-map-marker</v-icon>
                        {{ item.info.destination }}
                      </h3>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col align="left" lg="3" md="3" sm="12" cols="12" style="padding-bottom: 0;">
                  <v-row>
                    <v-col cols="12">
                      <h3 style="font-weight: 500;">
                        <v-icon :color="colorTheme">mdi-account-plus</v-icon>
                        {{ $t("CreatedBy") }}: {{ item.info.creator }}
                      </h3>
                    </v-col>
                    <v-col cols="12">
                      <h3 style="font-weight: 500;">
                        <v-icon :color="colorTheme">mdi-calendar-plus</v-icon>
                        {{ $t("date") }}: {{ item.info.creationDate }}
                      </h3>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row align="right">
                <v-col align="right" cols="12">
                  <v-btn
                    text
                    small
                    :color="colorTheme"
                    v-on:click="lastPosition(item)"
                  >{{ $t("lastPosition").toUpperCase() }}</v-btn>
                  <v-btn
                    text
                    small
                    :color="colorTheme"
                    v-on:click="OpenFinishTravel(item)"
                  >{{ $t("finalize").toUpperCase() }}</v-btn>
                  <v-btn
                    text
                    small
                    :color="colorTheme"
                    v-on:click="openEditTravel(item)"
                  >{{ $t("edit").toUpperCase() }}</v-btn>
                  <v-btn
                    text
                    small
                    :color="colorTheme"
                    v-on:click="openDeleteTravel(item)"
                  >{{ $t("delete").toUpperCase() }}</v-btn>
                </v-col>
              </v-row>
            </td>
            <td v-if="item.statusId == 2 || item.statusId == 3" :colspan="headers.length">
              <v-row align="right">
                <v-col align="right" cols="12">
                  <v-btn
                    text
                    small
                    :color="colorTheme"
                    v-on:click="lastPosition(item)"
                  >{{ $t("lastPosition").toUpperCase() }}</v-btn>
                  <v-btn
                    text
                    small
                    :color="colorTheme"
                    v-on:click="openAddTravel(item)"
                  >{{ $t("assignTrip").toUpperCase() }}</v-btn>
                </v-col>
              </v-row>
            </td>
            <td v-if="item.statusId == 4" :colspan="headers.length">
              <v-row align="right">
                <v-col align="right" cols="12">
                  <v-btn
                    text
                    small
                    :color="colorTheme"
                    v-on:click="lastPosition(item)"
                  >{{ $t("lastPosition").toUpperCase() }}</v-btn>
                </v-col>
              </v-row>
            </td>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >{{ $t("noResults") }} : "{{ searchTraffic }}".</v-alert>
          <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
        </v-data-table>
      </v-col>
      <div
        v-show="Maps"
        style="width: 920px; height: 590px; min-width: 540px; min-height: 410px;"
        id="myMapa"
        v-resize="options"
        v-if="this.$store.state.windowSize.width >= 1030"
      >
        <v-card>
          <v-toolbar id="myMapaHeader" color="#D3D3D3" flat dense>
            <v-toolbar-title>{{ $t("map").toUpperCase() }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn x-small height="50" text v-on:click="minimize()">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <v-btn x-small height="50" text v-on:click="closeMap()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card>
        <v-btn
          style="z-index: 40; position: absolute; bottom: 24px; right: 60px; font-size: 12px;"
          color="#8fad2e"
          dark
          rounded
          v-on:click="updatePosition()"
        >
          <v-icon>mdi-crosshairs-gps</v-icon>
          &nbsp;
          {{ $t("updatePosition").toUpperCase() }}
        </v-btn>
        <div id="map"></div>
      </div>
      <div id="fullMap" v-show="Maps" class="Mapa" v-else>
        <v-card>
          <v-toolbar id="Mapa" color="#D3D3D3" flat dense style="border-radius: 0;">
            <v-toolbar-title>{{ $t("map").toUpperCase() }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn x-small height="50" text v-on:click="closeMap()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card>
        <v-btn
          style="z-index: 40; position: absolute; bottom: 24px; right: 60px; font-size: 12px;"
          color="#8fad2e"
          dark
          rounded
          v-on:click="updatePosition()"
        >
          <v-icon>mdi-crosshairs-gps</v-icon>
          &nbsp;
          {{ $t("updatePosition").toUpperCase() }}
        </v-btn>
        <div id="map"></div>
      </div>
      <div v-show="windowsMinus">
        <v-card flat style="position: fixed; bottom: 30px; left: 120px; width: 200px;">
          <v-toolbar color="#D3D3D3" flat dense style="border-radius: 0;">
            <v-toolbar-title style="font-size: 20px">
              {{
              $t("map").toUpperCase()
              }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn x-small text v-on:click="maximize()">
                <v-icon>mdi-window-restore</v-icon>
              </v-btn>
              <v-btn x-small text @click="windowsMinus = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card>
      </div>
      <v-dialog v-model="deleteTravel" hide-overlay persistent width="330">
        <v-card>
          <v-card-title
            class="headline"
            style="font-size: 14px !important;"
          >{{ $t("deleteTravel") }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :color="colorTheme" @click="deleteTravel = false">
              {{
              $t("cancel").toUpperCase()
              }}
            </v-btn>
            <v-btn text :color="colorTheme" v-on:click="DeleteTravel(item)">
              {{
              $t("accept").toUpperCase()
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="finishTravel" hide-overlay persistent width="330">
        <v-card>
          <v-card-title
            class="headline"
            style="font-size: 14px !important;"
          >{{ $t("finishTravel") }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :color="colorTheme" @click="finishTravel = false">
              {{
              $t("cancel").toUpperCase()
              }}
            </v-btn>
            <v-btn text :color="colorTheme" v-on:click="FinishTravel()">
              {{
              $t("accept").toUpperCase()
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";
import VResize from "v-resize";
import drag from "@branu-jp/v-drag";
export default {
  name: "traffic",
  directives: {
    resize: VResize,
    drag
  },
  data() {
    return {
      search: "",
      Maps: false,
      windowsMinus: false,
      options: {
        onResize(params) {
          // console.log(params);
        },
        directions: ["right", "bottom", "left", "top"]
      },
      textOption: "",
      deleteTravel: false,
      finishTravel: false,
      deleteTrip: [],
      tripPositition: [],
      tripUpdate: false,
      finalizeTravel: [],
      searchTraffic: ""
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", this.$t("traffic"));
    this.$store.dispatch("getCarrierInfo");
    this.$store.commit("setPageHeader", [
      this.$t("dashboard"),
      "",
      "",
      "",
      true
    ]);
    this.$store.commit("filterTraffic", i18n.t("allStates"));
    this.$store.commit("skeletonTitleT", "outskeletonTitle");
    this.$store.commit("skeletonColumnT", "outskeletonColumn");
  },
  mounted() {
    this.$store.dispatch("ListOfTraffic");
    this.draggable();
    this.$store.commit("backgroundSkeleton");
  },
  computed: {
    ...mapState([
      "colorTheme",
      "optionsTraffic",
      "trafficList",
      "headersTraffic",
      "UpdatePosition",
      "whitesmoke",
      "backgroundSkeleton",
      "viewSkeletonsT",
      "progressOver"
    ]),
    filterTraffic: {
      get: function() {
        return this.$store.state.filterTraffic;
      },
      set: function(val) {
        if (val == i18n.t("allStates")) {
          this.searchTraffic = "";
        } else {
          this.searchTraffic = val;
        }
      }
    },
    skeletonTitleT: {
      get: function() {
        return this.$store.state.skeletonTitleT;
      },
      set: function() {}
    },
    skeletonColumnT: {
      get: function() {
        return this.$store.state.skeletonColumnT;
      },
      set: function() {}
    }
  },
  watch: {
    UpdatePosition() {
      this.tripUpdate = true;
      this.tripPositition.lat = this.UpdatePosition.Lat;
      this.tripPositition.lng = this.UpdatePosition.Lon;
      this.lastPosition(this.tripPositition);
    },
    search(val) {
      this.searchTraffic = val;
    }
  },
  methods: {
    draggable: function() {
      dragElement(document.getElementById("myMapa"));
      function dragElement(elmnt) {
        var pos1 = 0,
          pos2 = 0,
          pos3 = 0,
          pos4 = 0;
        if (document.getElementById(elmnt.id + "Header")) {
          /* if present, the header is where you move the DIV from:*/
          document.getElementById(
            elmnt.id + "Header"
          ).onmousedown = dragMouseDown;
        } else {
          /* otherwise, move the DIV from anywhere inside the DIV:*/
          elmnt.onmousedown = dragMouseDown;
        }

        function dragMouseDown(e) {
          e = e || window.event;
          e.preventDefault();
          // get the mouse cursor position at startup:
          pos3 = e.clientX;
          pos4 = e.clientY;
          document.onmouseup = closeDragElement;
          // call a function whenever the cursor moves:
          document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
          e = e || window.event;
          e.preventDefault();
          // calculate the new cursor position:
          pos1 = pos3 - e.clientX;
          pos2 = pos4 - e.clientY;
          pos3 = e.clientX;
          pos4 = e.clientY;
          // set the element's new position:
          elmnt.style.top = elmnt.offsetTop - pos2 + "px";
          elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
        }

        function closeDragElement() {
          /* stop moving when mouse button is released:*/
          document.onmouseup = null;
          document.onmousemove = null;
        }
      }
    },
    closeMap: function() {
      if (this.$store.state.windowSize.width <= 1030) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
      this.Maps = false;
    },
    maximize: function() {
      this.Maps = true;
      this.windowsMinus = false;
    },
    minimize: function() {
      this.Maps = false;
      this.windowsMinus = true;
    },
    lastPosition: function(val) {
      if (!this.tripUpdate) {
        this.tripPositition = val;
      }
      this.tripUpdate = false;
      this.Maps = true;
      if (this.$store.state.windowSize.width <= 1030) {
        var elem = document.getElementById("fullMap");
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
      }
      //  console.log(val);
      var lat = parseInt(val.lat);
      var lng = parseInt(val.lng);

      var map = new google.maps.Map(document.getElementById("map"), {
        zoom: 8,
        center: { lat, lng }
      });
      //var geocoder = new google.maps.Geocoder();
      //setTimeout(this.geocodeLatLng(geocoder, map, val), 8000);
    },
    geocodeLatLng: function(geocoder, map, val) {
      var cordenadas = [val.lat, val.lng];

      var latlng = {
        lat: parseFloat(cordenadas[0]),
        lng: parseFloat(cordenadas[1])
      };
      // geocoder.geocode({ location: latlng }, function(results, status) {
      //   if (status === "OK") {
      //     if (results[0]) {
      //       map.setZoom(18);

      //       var ubicacion = results[0].formatted_address;
      //       var contentString =
      //         '<div style="text-align: justify; max-width: 340px;" id="content">' +
      //         '<h4 style="margin-bottom: 10px;">' +
      //         val.vehicle +
      //         "</h4>" +
      //         '<div id="bodyContent">' +
      //         '<p style="margin-bottom: 0;">' +
      //         ubicacion +
      //         "</p>" +
      //         '<p style="margin-bottom: 0;">' +
      //         val.date +
      //         "</p>" +
      //         "</div>" +
      //         "</div>";
      //       var infowindow = new google.maps.InfoWindow({
      //         content: contentString
      //       });

      //       var marker = new google.maps.Marker({
      //         position: latlng,
      //         map: map
      //       });
      //       infowindow.open(map, marker);
      //       marker.addListener("click", function() {
      //         infowindow.open(map, marker);
      //       });
      //     } else {
      //       window.alert("No results found");
      //     }
      //   } else {
      //     window.alert("Geocoder failed due to: " + status);
      //   }
      // });
    },
    openAddTravel(val) {
      if (val != null) {
        this.$store.commit("asigTrip", val);
      }
      this.$router.push({ name: "addTravel" });
    },
    openEditTravel(val) {
      this.$store.commit("editTravel", val);
      this.$router.push({ name: "editTravel" });
    },
    openDeleteTravel(val) {
      this.deleteTrip = val;
      this.deleteTravel = true;
    },
    DeleteTravel() {
      this.$store.dispatch("DeleteTrip", this.deleteTrip.info.TripId);
      this.deleteTravel = false;
    },
    updatePosition() {
      this.$store.dispatch("UpdatePosition", this.tripPositition);
    },
    OpenFinishTravel(val) {
      this.finishTravel = true;
      this.finalizeTravel = val;
    },
    FinishTravel() {
      //  console.log(this.finalizeTravel);
      this.$store.dispatch("EditTrip", this.finalizeTravel);
      this.finishTravel = false;
    }
  }
};
</script>

<style scoped>
.Mapa {
  position: absolute;
  border: 5px solid lightgray;
  overflow: hidden;
  z-index: 20;
}

#myMapa {
  position: absolute;
  border: 5px solid lightgray;
  overflow: hidden;
  z-index: 20;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

#myMapaHeader {
  border-radius: 0;
}

.firstHeading {
  padding-bottom: 10px;
}

#map {
  min-width: 200px;
  height: calc(100% - 48px);
}

@import "./../assets/styles/skeletons.css";
</style>
